// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".new-favorite-form[data-v-69379412]{width:100%;margin:0}\n", ""]);
// Exports
module.exports = exports;
